
export const TREATMENT_QUOTATION_CREATED = 'treatment_quotation_created'



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/set-and-shop-scan/state-name.js